import React, { useState } from "react";
import {
    CircularProgress, IconButton, ListItem, ListItemIcon,
    ListItemText, Tooltip, Typography,
} from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";

import {
    descargarAdjunto,
    previsualizarAdjunto,
    esPrevisualizble,
} from "../services/audit.service";

const fmtSize = (b) => {
    if (!b) return "";
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};

function MimeIcon({ mimeType }) {
    if (mimeType === "application/pdf")
        return <PictureAsPdfIcon sx={{ fontSize: 15, color: "#ef4444" }} />;
    if (mimeType?.startsWith("image/"))
        return <ImageIcon sx={{ fontSize: 15, color: "#3b82f6" }} />;
    return <InsertDriveFileIcon sx={{ fontSize: 15 }} color="action" />;
}

export default function AuditAdjuntoItem({ adj }) {
    const [loadingPreview, setLoadingPreview] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);

    const puedeVer = esPrevisualizble(adj.mime_type);

    const handlePreview = async () => {
        setLoadingPreview(true);
        try {
            await previsualizarAdjunto(adj.id);
        } catch {
            alert("No se pudo abrir el archivo.");
        } finally {
            setLoadingPreview(false);
        }
    };

    const handleDownload = async () => {
        setLoadingDownload(true);
        try {
            await descargarAdjunto(adj.id, adj.nombre_original);
        } catch {
            alert("No se pudo descargar el archivo.");
        } finally {
            setLoadingDownload(false);
        }
    };

    return (
        <ListItem
            disableGutters
            sx={{ py: 0.4, borderBottom: "1px solid", borderColor: "divider" }}
            secondaryAction={
                <span style={{ display: "flex", gap: 2 }}>
                    {puedeVer && (
                        <Tooltip title="Ver archivo">
                            <span>
                                <IconButton size="small" onClick={handlePreview} disabled={loadingPreview}>
                                    {loadingPreview
                                        ? <CircularProgress size={13} />
                                        : <VisibilityIcon sx={{ fontSize: 15, color: "primary.main" }} />}
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}
                    <Tooltip title="Descargar">
                        <span>
                            <IconButton size="small" onClick={handleDownload} disabled={loadingDownload}>
                                {loadingDownload
                                    ? <CircularProgress size={13} />
                                    : <DownloadIcon sx={{ fontSize: 15 }} />}
                            </IconButton>
                        </span>
                    </Tooltip>
                </span>
            }
        >
            <ListItemIcon sx={{ minWidth: 26 }}>
                <MimeIcon mimeType={adj.mime_type} />
            </ListItemIcon>
            <ListItemText
                primary={
                    <Typography variant="body2" noWrap sx={{ maxWidth: 220 }}>
                        {adj.nombre_original}
                    </Typography>
                }
                secondary={
                    <Typography variant="caption" color="text.secondary">
                        {fmtSize(adj.tamanio)}
                        {adj.subido_por_nombre ? ` · ${adj.subido_por_nombre}` : ""}
                    </Typography>
                }
            />
        </ListItem>
    );
}